import { token } from '../di';
import { IToastManager } from './types';

export const TOAST_TOKEN = token<IToastManager>('Toast/Manager');
